<template>
	<div id="wrap" :style="{ height: screenHeight + 'px' }">
		<div id="main" :style="{ top: nowTop + 'px' }">
			<div id="page1" class="page position-relative" :style="note">
				<div>
					<Userheard></Userheard>
				</div>
				<div class="buttom-text">
					<p>版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All rights reserved.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/home.css"
	import "@/assets/css/public.css"
	import Userheard from './userheard.vue'
	export default {
		components: {
			Userheard
		},
		data() {
			return {
				screenWeight: 0, // 屏幕宽度
				screenHeight: 0, // 屏幕高度
				index: 1, // 用于判断翻页
				curIndex: 1, // 当前页的index
				startTime: 0, // 翻屏起始时间  
				endTime: 0, // 上一次翻屏结束时间
				nowTop: 0, // 翻屏后top的位置
				pageNum: 0, // 一共有多少页
				main: Object,
				obj: Object,
				note: {
				backgroundImage: "url(" + require("../../assets/img/bg-login.jpg") + ")",
				backgroundRepeat: "no-repeat",
				backgroundSize: "100% 100%",
				},
			}
		},
		mounted() {
			this.screenWeight = document.documentElement.clientWidth;
			this.screenHeight = document.documentElement.clientHeight;
			this.main = document.getElementById("main");
			this.obj = document.getElementsByTagName("div");
			for (let i = 0; i < this.obj.length; i++) {
				if (this.obj[i].className == 'page') {
					this.obj[i].style.height = this.screenHeight + "px";
				}
			}
			this.pageNum = document.querySelectorAll(".page").length;

			// 浏览器兼容      
			if ((navigator.userAgent.toLowerCase().indexOf("firefox") != -1)) {
				document.addEventListener("DOMMouseScroll", this.scrollFun, false);
			} else if (document.addEventListener) {
				document.addEventListener("mousewheel", this.scrollFun, false);
			} else if (document.attachEvent) {
				document.attachEvent("onmousewheel", this.scrollFun);
			} else {
				document.onmousewheel = this.scrollFun;
			}
		},
		methods: {
					nameber(){
						console.log(this.textarea)
						var textarea=document.getElementById("ta");
						var value=textarea.value;
						var text_array=value.split("\n");
						let kong= text_array
						this.textarea= kong.filter(item=>item)
						console.log(this.textarea)
					},
			scrollFun(event) {
				this.startTime = new Date().getTime();
				// mousewheel事件中的 “event.wheelDelta” 属性值：返回的如果是正值说明滚轮是向上滚动
				// DOMMouseScroll事件中的 “event.detail” 属性值：返回的如果是负值说明滚轮是向上滚动
				let delta = event.detail || (-event.wheelDelta);
				// 如果当前滚动开始时间和上次滚动结束时间的差值小于1.5s，则不执行翻页动作，这样做是为了实现类似节流的效果
				if ((this.startTime - this.endTime) > 1500) {
					if (delta > 0 && parseInt(this.main.offsetTop) >= -(this.screenHeight * (this.pageNum - 2))) {
						// 向下滚动
						this.index++;
						this.toPage(this.index);
					} else if (delta < 0 && parseInt(this.main.offsetTop) < 0) {
						// 向上滚动
						this.index--;
						this.toPage(this.index);
					}
					// 本次翻页结束，记录结束时间，用于下次判断
					this.endTime = new Date().getTime();
				}
			},
			// 翻页
			toPage(index) {
				if (index != this.curIndex) {
					let delta = index - this.curIndex;
					this.nowTop = this.nowTop - delta * this.screenHeight;
					this.curIndex = index;
				}
			}
		}
	}
</script>


<style scoped>
	.el-button--primary {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--primary:hover {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--primary:focus {
		background-color: #FD9405;
		border-color: #FD9405;
	}
	.el-form-item__label{
		font-size: 18px;
		color:#FFFFFF ;
	}
</style>



// WEBPACK FOOTER //
// src/components/public/body.vue